import MeaPage from "../../../components/MeaPage";
import { useEffect, useRef, useState } from "react";
import { Checkbox } from "primereact/checkbox";
import trainingsAPI from "../../../services/trainings";
import { useParams } from "react-router-dom";
import { Dropdown } from "primereact/dropdown";
import MeaButton from "../../../components/MeaButton";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import tasksAPI from "../../../services/tasks";
import { Panel } from "primereact/panel";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ToFormatedDateWithWeekday, ToFormatedHour } from "../../../utils/dates";

const TrainingImportPage = () => {
  const params = useParams();
  const schoolId = params.schoolId;
  const trainingId = params.trainingId;
  const accessToken = "";

  const [loading, setLoading] = useState(false);
  const [hasLogs, setHasLogs] = useState(false);
  const [logsTitle, setLogsTitle] = useState(null);
  const [logs, setLogs] = useState([]);

  const [selectedSourceTraining, setSelectedSourceTraining] = useState(null);

  const trainingQuery = trainingsAPI.useGetList(schoolId, accessToken, 1, 10000);
  const trainings = trainingQuery?.data?.data;
  const filteredTrainings = trainings?.filter((training) => training.id !== trainingId);

  const resultsRef = useRef(null);

  const categories = [
    { name: "Salles", key: "classrooms" },
    { name: "Créneaux", key: "slots" },
    { name: "Niveaux/Classes/Matières", key: "levels" },
    { name: "Enseignant(e)s", key: "teachers" },
    { name: "Programme de la semaine", key: "schedule" },
  ];

  const [selectedCategories, setSelectedCategories] = useState([]);

  const onCategoryChange = (e) => {
    let _selectedCategories = [...selectedCategories];
    if (e.checked) {
      _selectedCategories.push(e.value);
    } else {
      _selectedCategories = _selectedCategories.filter(
        (category) => category.key !== e.value.key,
      );
    }
    setSelectedCategories(_selectedCategories);
  };

  const [jobId, setJobId] = useState(null);

  const handleImport = () => {
    setLoading(true);
    setLogsTitle("Importation en cours...");
    setLogs([]);
    tasksAPI
      .ImportFromTraining(schoolId, trainingId, accessToken, {
        source_training_id: selectedSourceTraining,
        elements: selectedCategories.map((category) => category.key),
      })
      .then((json) => {
        setJobId(json?.data?.id);
        setHasLogs(true);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    const fetchTaskStatus = async () => {
      tasksAPI
        .GetTask(schoolId, trainingId, jobId, accessToken)
        .then((data) => {
          setLogsTitle(data?.data?.message);
          setLogs(data?.data?.job_logs || []);

          if (data?.data?.status === "COMPLETED") {
            setLoading(false);
            setJobId(null);
          } else if (data?.data?.status === "FAILED") {
            setLoading(false);
            setJobId(null);
          } else {
            setTimeout(fetchTaskStatus, 1000);
          }
        })
        .catch((error) => {
          console.log("error " + error);
          setJobId(null);
          setLoading(false);
        });
    };

    if (loading && jobId) {
      fetchTaskStatus();
    }
  }, [loading, jobId, schoolId, trainingId, accessToken]);

  return (
    <MeaPage
      title="Importer des données"
      subtitle="Importer des données à partir d'une autre formation"
    >
      <ConfirmDialog />
      <div className="flex flex-column mt-3 p-5 bg-white">
        <div>
          Sélectionnez une ancienne formation et choisissez quelles données importer
          dans cette nouvelle formation.
        </div>
        <div className="mb-4">
          Les données importées seront des copies et n'affecteront en aucun cas la
          formation source.
        </div>
        <div className="text-900 w-full md:w-10 md:flex-order-0 flex-order-1">
          <ul className="list-none p-0 m-0">
            <li className="flex align-items-start py-2 px-2 flex-wrap border-bottom-1 surface-border pb-5">
              <div className="text-500 w-full md:w-3 font-medium">Formation source</div>
              <div className="text-900 w-full md:w-9">
                <Dropdown
                  disabled={hasLogs}
                  value={filteredTrainings?.find(
                    (training) => training?.id === selectedSourceTraining,
                  )}
                  options={filteredTrainings || []}
                  optionLabel="name"
                  placeholder="Sélectionner une formation"
                  onChange={(e) => setSelectedSourceTraining(e.value?.id)}
                />
              </div>
            </li>
            <li className="flex align-items-start py-2 px-2 flex-wrap border-bottom-1 surface-border pb-5">
              <div className="text-500 w-full md:w-3 font-medium">Les données à importer</div>
              <div className="text-900 w-full md:w-9">
                <div className="flex flex-column gap-3">
                  {categories.map((category) => (
                    <div key={category.key} className="flex align-items-center">
                      <Checkbox
                        disabled={hasLogs}
                        inputId={category.key}
                        name="category"
                        value={category}
                        onChange={onCategoryChange}
                        checked={selectedCategories.some(
                          (item) => item.key === category.key,
                        )}
                      />
                      <label htmlFor={category.key} className="ml-2">
                        {category.name}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            </li>
            <li>
              <MeaButton
                label="Importer"
                disabled={
                  hasLogs ||
                  selectedSourceTraining === null ||
                  selectedCategories?.length === 0
                }
                loading={loading}
                className="mt-5"
                onClick={(e) => {
                  e.stopPropagation();

                  confirmDialog({
                    message:
                      "Voulez-vous procéder à l'importation des données sélectionnées ?",
                    header: "Confirmation",
                    icon: "pi pi-info-circle",
                    acceptLabel: "Oui",
                    rejectLabel: "Non",
                    defaultFocus: "reject",
                    reject: () => {
                      setLoading(false);
                    },
                    accept: () => {
                      handleImport();
                    },
                  });
                }}
              />
              {hasLogs && !loading && (
                <MeaButton
                  label="Fermer"
                  outlined
                  className="mt-5 ml-3"
                  onClick={() => window.history.back()}
                />
              )}
            </li>
            {hasLogs && (
              <li className="mt-3">
                <Panel ref={resultsRef} header={logsTitle} toggleable collapsed>
                  <DataTable value={logs} size="small">
                    <Column
                      field="log_type"
                      header="Type"
                      body={(item) => (
                        <span
                          className={
                            item?.log_type === "WARNING"
                              ? "text-orange-500"
                              : item?.log_type === "ERRR"
                                ? "text-red-500"
                                : ""
                          }
                        >
                          {item?.log_type}
                        </span>
                      )}
                    ></Column>
                    <Column field="message" header="Message"></Column>
                    <Column
                      field="created_at"
                      header="Fait le"
                      body={(item) => (
                        <>
                          {ToFormatedDateWithWeekday(new Date(item?.created_at)) +
                            "  " +
                            ToFormatedHour(new Date(item?.created_at))}
                        </>
                      )}
                    ></Column>
                  </DataTable>
                </Panel>
              </li>
            )}
          </ul>
        </div>
      </div>
    </MeaPage>
  );
};

export default TrainingImportPage;
